/*
 * Tencent is pleased to support the open source community by making
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) available.
 *
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.  All rights reserved.
 *
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) is licensed under the MIT License.
 *
 * License for 蓝鲸智云PaaS平台 (BlueKing PaaS):
 *
 * ---------------------------------------------------
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 * documentation files (the "Software"), to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
 * to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of
 * the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
 * THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF
 * CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

import { h } from 'vue';

import { commonSVGProps } from '../common';

// 说明：以下流程状态图标均来自设计稿（节点 179-5450 等）。
// 为保证与设计稿像素一致且零手改坐标风险，统一保留设计稿原始 path 坐标，
// 仅通过偏移 viewBox 将对应状态裁剪到 32×32 视口中心，再由容器统一缩放到 16px。
export const BkFlowSuccessIcon = h(
  'svg',
  {
    ...commonSVGProps,
    viewBox: '0 0 32 32',
    class: {
      [commonSVGProps.class]: true,
      'ai-bk-flow-success-icon': true,
    },
  },
  [
    h('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 2C23.7313 2 30 8.26875 30 16C30 23.7313 23.7313 30 16 30C8.26875 30 2 23.7313 2 16C2 8.26875 8.26875 2 16 2ZM22.0028 11L14.0038 19L10 15L8.5 16.5026L14.0038 22L23.5 12.5L22.0028 11Z',
      fill: '#65C389',
    }),
  ],
);

export const BkFlowFailedIcon = h(
  'svg',
  {
    ...commonSVGProps,
    viewBox: '0 0 32 32',
    class: {
      [commonSVGProps.class]: true,
      'ai-bk-flow-failed-icon': true,
    },
  },
  [
    h('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 2C23.7313 2 30 8.26875 30 16C30 23.7313 23.7313 30 16 30C8.26875 30 2 23.7313 2 16C2 8.26875 8.26875 2 16 2ZM20.2426 10.3431L15.9996 14.5862L11.757 10.3435L10.3431 11.7574L14.5858 16L10.3431 20.2426L11.758 21.6575L16.0006 17.4149L20.2426 21.6569L21.6565 20.243L17.4145 16.001L21.6575 11.758L20.2426 10.3431Z',
      fill: '#FF5656',
    }),
  ],
);

export const BkFlowSuspendedIcon = h(
  'svg',
  {
    ...commonSVGProps,
    viewBox: '0 0 32 32',
    class: {
      [commonSVGProps.class]: true,
      'ai-bk-flow-suspended-icon': true,
    },
  },
  [
    h('path', {
      d: 'M16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2ZM14 10H11V22H14V10ZM21 10H18V22H21V10Z',
      fill: '#F59500',
    }),
  ],
);

export const BkFlowPendingIcon = h(
  'svg',
  {
    ...commonSVGProps,
    viewBox: '0 0 32 32',
    class: {
      [commonSVGProps.class]: true,
      'ai-bk-flow-pending-icon': true,
    },
  },
  [
    h('path', {
      d: 'M16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2ZM9.69434 7.7002C9.14293 7.7002 8.7002 8.15033 8.7002 8.7002V8.74023C8.70032 9.28999 9.14301 9.74023 9.69434 9.74023H11.1191V12.1201C11.1192 13.6989 11.8616 15.1043 13.0137 16C11.8616 16.8957 11.1192 18.3011 11.1191 19.8799V22.2598H9.71387C9.69649 22.2598 9.67908 22.2608 9.66211 22.2627C9.14435 22.2999 8.73938 22.734 8.73926 23.2598V23.2998C8.73926 23.8316 9.15347 24.2693 9.67969 24.2979C9.69103 24.2987 9.70239 24.2998 9.71387 24.2998H22.3057C22.8571 24.2998 23.2998 23.8497 23.2998 23.2998V23.2598C23.2997 22.71 22.857 22.2598 22.3057 22.2598H20.8408V19.8799C20.8408 18.3007 20.0978 16.8956 18.9453 16C20.0978 15.1044 20.8408 13.6993 20.8408 12.1201V9.74023H22.2666C22.8178 9.74006 23.2606 9.28989 23.2607 8.74023V8.7002C23.2607 8.15043 22.8179 7.70037 22.2666 7.7002H9.69434ZM22.4463 23.9854L22.3057 24C22.3951 24 22.48 23.9813 22.5586 23.9502C22.5223 23.9645 22.4852 23.9773 22.4463 23.9854ZM9.05273 23.4316C9.06084 23.4745 9.07245 23.516 9.08789 23.5557C9.07298 23.5174 9.06081 23.4777 9.05273 23.4365V23.4316ZM9.44531 22.623C9.48274 22.6058 9.52184 22.5915 9.5625 22.5811L9.56445 22.5801C9.5231 22.5906 9.48336 22.6054 9.44531 22.623ZM15.9805 17.0195C16.7368 17.0196 17.447 17.3158 17.9814 17.8564L17.9824 17.8574C18.5188 18.3966 18.8134 19.1145 18.8135 19.8799V22.2598H13.1475V19.8799C13.1475 19.1145 13.4412 18.3966 13.9775 17.8574L13.9785 17.8564C14.5131 17.3156 15.2239 17.0195 15.9805 17.0195ZM18.8135 9.74023V12.1201C18.8134 12.8855 18.5188 13.6034 17.9824 14.1426L17.9814 14.1436C17.447 14.6842 16.7368 14.9804 15.9805 14.9805C15.2239 14.9805 14.5131 14.6844 13.9785 14.1436L13.9775 14.1426L13.7881 13.9316C13.3725 13.4226 13.1475 12.7897 13.1475 12.1201V9.74023H18.8135ZM12.875 12.5459C12.87 12.5086 12.866 12.4712 12.8623 12.4336L12.8506 12.2773C12.8549 12.3676 12.8632 12.4572 12.875 12.5459Z',
      fill: '#B8BBC4',
    }),
  ],
);

export const BkFlowSkippedIcon = h(
  'svg',
  {
    ...commonSVGProps,
    viewBox: '0 0 32 32',
    class: {
      [commonSVGProps.class]: true,
      'ai-bk-flow-skipped-icon': true,
    },
  },
  [
    h('path', {
      d: 'M16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2ZM17.0156 8.8125C16.6831 8.81258 16.4131 9.08514 16.4131 9.4209V11.8574L16.3984 11.8594C14.1864 12.2432 12.5291 13.4566 12.3467 13.5947C11.5353 14.1512 10.813 14.8455 10.1973 15.6533C9.70507 16.3019 9.28342 17.0276 8.93945 17.8086C8.4036 19.027 8.23229 19.9214 8.19238 20.167V20.1709C8.18865 20.1842 8.18638 20.1997 8.18262 20.2168L8.18066 20.2246C8.16356 20.309 8.13736 20.4356 8.12598 20.6387C8.11649 20.8244 8.18634 20.9396 8.24707 21.0049C8.33639 21.1008 8.46603 21.1533 8.61426 21.1533C8.8347 21.1533 9.00412 20.9708 9.15234 20.8115L9.1543 20.8096C9.17706 20.7847 9.19793 20.7613 9.2207 20.7383C9.86489 20.0898 10.6804 19.5176 11.5811 19.084C12.3449 18.7176 13.2058 18.4188 14.1387 18.1963C15.0584 17.9775 15.8738 17.8771 16.3945 17.8311L16.415 17.8291V20.5596C16.415 20.8953 16.6851 21.1679 17.0176 21.168L16.999 21.1836L17.0371 21.1875L17.0176 21.168C17.1639 21.168 17.3068 21.1145 17.417 21.0166L23.6729 15.4385C23.6918 15.4213 23.7086 15.4039 23.7256 15.3848C23.9441 15.1315 23.9197 14.748 23.6709 14.5254L17.415 8.96387C17.3048 8.86601 17.1619 8.8125 17.0156 8.8125Z',
      fill: '#5B7290',
    }),
  ],
);

export const ExecutionIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-execution-icon': true,
    },
  },
  [
    h('path', {
      'fill-rule': 'evenodd',
      d: 'M512 64A448 448 0 1 1 64 512 448 448 0 0 1 512 64Zm0 64A384 384 0 0 0 128 512 384 384 0 0 0 784 784 384 384 0 0 0 784 240 384 384 0 0 0 512 128ZM448 576V256h64V512H768v64Z',
    }),
  ],
);

export const NodeOutputIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-node-output-icon': true,
    },
  },
  [
    h('path', {
      d: 'M800 128c17.664 0 32 12.288 32 27.424v545.408L594.016 896H224c-17.664 0-32-12.288-32-27.424V155.424C192 140.288 206.336 128 224 128z m-26.176 59.072H250.176v649.856h276.384v-134.88c0-31.52 28.704-57.12 64-57.12h183.264V187.072zM735.52 704h-144.96a13.024 13.024 0 0 0-5.824 1.216v122.432L735.52 704zM704 480v64H320v-64h384z m-128-96v64h-256v-64h256z m96-128v64H320V256h352z',
    }),
  ],
);

export const NodeTabIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-node-tab-icon': true,
    },
  },
  [
    h('path', {
      d: 'M374.656 640c57.184 0 105.184 41.088 118.72 96.384 1.312-0.16 2.624-0.384 3.968-0.384h368c16.928 0 30.656 14.336 30.656 32s-13.76 32-30.656 32h-368c-1.376 0-2.656-0.256-3.936-0.384-13.568 55.296-61.568 96.384-118.72 96.384-57.184 0-105.216-41.088-118.72-96.384-1.344 0.16-2.624 0.384-3.968 0.384H190.656C173.76 800 160 785.664 160 768s13.76-32 30.656-32h61.344c1.344 0 2.624 0.256 3.936 0.384C269.472 681.088 317.504 640 374.656 640z m0 64c-33.824 0-61.312 28.704-61.312 64s27.52 64 61.312 64c33.824 0 61.344-28.704 61.344-64s-27.52-64-61.344-64z m306.688-320c57.152 0 105.184 41.088 118.72 96.384 1.28-0.16 2.56-0.384 3.936-0.384h61.344c16.928 0 30.656 14.336 30.656 32s-13.76 32-30.656 32h-61.344c-1.344 0-2.624-0.256-3.936-0.384-13.536 55.296-61.568 96.384-118.72 96.384-57.184 0-105.184-41.088-118.72-96.384-1.312 0.16-2.624 0.384-3.968 0.384h-368C173.76 544 160 529.664 160 512s13.76-32 30.656-32h368c1.376 0 2.656 0.256 3.936 0.384 13.568-55.296 61.568-96.384 118.72-96.384z m0 64c-33.824 0-61.344 28.704-61.344 64s27.52 64 61.344 64 61.312-28.704 61.312-64-27.52-64-61.312-64z m-306.688-288c57.184 0 105.184 41.088 118.72 96.384 1.312-0.16 2.624-0.384 3.968-0.384h368c16.928 0 30.656 14.336 30.656 32s-13.76 32-30.656 32h-368c-1.376 0-2.656-0.256-3.936-0.384-13.568 55.296-61.568 96.384-118.72 96.384-57.184 0-105.216-41.088-118.72-96.384-1.344 0.16-2.624 0.384-3.968 0.384H190.656C173.76 320 160 305.664 160 288s13.76-32 30.656-32h61.344c1.344 0 2.624 0.256 3.936 0.384C269.472 201.088 317.504 160 374.656 160z m0 64c-33.824 0-61.312 28.704-61.312 64s27.52 64 61.312 64c33.824 0 61.344-28.704 61.344-64s-27.52-64-61.344-64z',
    }),
  ],
);
